module.exports = __webpack_public_path__ + "img/cdldh.ee706f1b.png";